import { getIdfcAuthUrl } from "_services";
import { useCallback } from "react";
import toast from "react-hot-toast";

const useAuthFlow = (callBackFuntion) => {

  const getAuthUrl = useCallback(async (item) => {
    try {
      const param = { referenceNumber: item.referenceNumber };
      const res = await getIdfcAuthUrl(param);
      if (res?.responseCode === 200 && res?.data?.authURL) {
        return res.data.authURL;
      } else {
        toast.error("Something went wrong.");
        return null;
      }
    } catch (error) {
      console.error("Submission Error:", error);
      return null;
    }
  }, []);


  const fetchWithAuth = useCallback(
    async (item, forceToAuth = false,selectedItem = null) => {
      const isTokenValid = () => {
        if (!item?.auth_token || !item?.auth_token_expires_at) return false;
        const expiresAt = new Date(item.auth_token_expires_at).getTime();
        const now = Date.now();
        const FIVE_MIN = 5 * 60 * 1000;
        return expiresAt - now > FIVE_MIN;
      };

      if (!isTokenValid() || forceToAuth) {
        const url = await getAuthUrl(item);
        if (!url) return;

        const popup = window.open(url, "BankLogin", "width=600,height=600");

        const handleMessage = (event) => {
          const { responseCode, data } = event.data || {};
          if (responseCode === 200 && data?.auth_token) {
            callBackFuntion(item, data.auth_token, data,selectedItem);

            window.removeEventListener("message", handleMessage);
            if (popup && !popup.closed) popup.close();
          }
        };

        window.addEventListener("message", handleMessage);
      } else {
        callBackFuntion(item, item?.auth_token,null,selectedItem);
      }
    },
    [callBackFuntion, getAuthUrl]
  );

  return { fetchWithAuth, getAuthUrl };
};

export default useAuthFlow;